<template>
    <headroom style="height: 0px;">
        <header class="header-global">
            <base-nav
                class="navbar-main "
                transparent
                type=""
                effect="light"
                expand
            >

                <router-link
                    slot="brand"
                    class="navbar-brand mr-lg-5 "
                    to="/"
                >
                    <icon-logoHorizontal
                        height="24"
                        width="132"
                        class="iconBase-white "
                    />
                </router-link>

                <div
                    class="row"
                    slot="content-header"
                    slot-scope="{closeMenu}"
                >
                    <div class="col-6 collapse-brand">
                        <router-link
                            slot="brand"
                            class="navbar-brand mr-lg-5 "
                            to="/"
                        >
                            <icon-logoHorizontal
                                height="24"
                                width="132"
                                class="iconBase "
                            />
                        </router-link>
                    </div>
                    <div class="col-6 collapse-close">
                        <close-button @click="closeMenu"></close-button>
                    </div>
                </div>

                <ul class="navbar-nav navbar-nav-hover align-items-lg-center">

                    <li class="nav-item">
                        <router-link
                            to="/principe"
                            class="nav-link"
                        >
                            <i class="ni ni-ui-04 d-lg-none"></i>
                            <span class="nav-link-color">
                                Le Principe
                            </span>
                        </router-link>
                    </li>
                    <!-- MENU PRODUCTEURS & PARTENAIRES
                    <base-dropdown
                        class="nav-item"
                        menu-classes="dropdown-menu-xl"
                    >
                        <a
                            slot="title"
                            href="#"
                            class="nav-link"
                            data-toggle="dropdown"
                            role="button"
                        >
                            <i class="ni ni-ui-04 d-lg-none"></i>
                            <span class="nav-link-inner--text">Nos Produits</span>
                        </a>
                        <div class="dropdown-menu-inner">
                            <a
                                href="#"
                                class="media d-flex align-items-center"
                            >
                                <div class="icon icon-shape bg-gradient-success rounded-circle text-white">
                                    <i class="ni ni-spaceship"></i>
                                </div>
                                <div class="media-body ml-3">
                                    <h6 class="heading text-success mb-md-1">Fruits et Légumes</h6>
                                    <p class="description d-none d-md-inline-block mb-0">Issus de l'agriculture biologique où raisonée</p>
                                </div>
                            </a>
                            <a
                                href="#"
                                class="media d-flex align-items-center"
                            >
                                <div class="icon icon-shape bg-gradient-warning rounded-circle text-white">
                                    <i class="ni ni-ui-04"></i>
                                </div>
                                <div class="media-body ml-3">
                                    <h5 class="heading text-warning mb-md-1">épicerie & vrac</h5>
                                    <p class="description d-none d-md-inline-block mb-0">Produits et locaux & artisanaux.</p>
                                </div>
                            </a>
                            <a
                                href="#"
                                class="media d-flex align-items-center"
                            >
                                <div class="icon icon-shape bg-gradient-pink rounded-circle text-white">
                                    <i class="ni ni-ui-04"></i>
                                </div>
                                <div class="media-body ml-3">
                                    <h5 class="heading text-pink mb-md-1">Cosmétiques & Hygiènnes</h5>
                                    <p class="description d-none d-md-inline-block mb-0">Tous nos produits sont 100% naturel </p>
                                </div>
                            </a>
                        </div>
                    </base-dropdown>
                    <base-dropdown
                        tag="li"
                        class="nav-item "
                    >
                        <a
                            slot="title"
                            href="#"
                            class="nav-link"
                            data-toggle="dropdown"
                            role="button"
                        >
                            <i class="ni ni-collection d-lg-none"></i>
                            <span class="nav-link-inner--text">Nos partenaires</span>
                        </a>
                        <router-link
                            to="/landing"
                            class="heading dropdown-item"
                        >Les éleveurs</router-link>
                        <router-link
                            to="/profile"
                            class="heading dropdown-item"
                        >Les cultivateurs</router-link>
                        <router-link
                            to="/login"
                            class="heading dropdown-item"
                        >Les produteurs</router-link>
                        <router-link
                            to="/register"
                            class="heading dropdown-item"
                        >Register</router-link>
                    </base-dropdown>
                    -->
                    <li class="nav-item">

                        <router-link
                            to="/contact"
                            class="nav-link"
                        >
                            <i class="ni ni-ui-04 d-lg-none"></i>
                            <span class="nav-link-color">
                                Contact
                            </span>
                        </router-link>
                    </li>

                </ul>
                <!-- MENU RESEAUX SOCIAUX 
                <ul class="navbar-nav align-items-lg-center ml-lg-auto">
                    <li class="nav-item">
                        <a
                            class="nav-link nav-link-icon"
                            href="https://www.facebook.com/creativetim"
                            target="_blank"
                            rel="noopener"
                            data-toggle="tooltip"
                            title="Like us on Facebook"
                        >
                            <i class="fa fa-facebook-square"></i>
                            <span class="nav-link-inner--text d-lg-none">Facebook</span>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a
                            class="nav-link nav-link-icon"
                            href="https://www.instagram.com/creativetimofficial"
                            target="_blank"
                            rel="noopener"
                            data-toggle="tooltip"
                            title="Follow us on Instagram"
                        >
                            <i class="fa fa-instagram"></i>
                            <span class="nav-link-inner--text d-lg-none">Instagram</span>
                        </a>
                    </li>
                </ul>
                -->
            </base-nav>
        </header>
    </headroom>
</template>
<script>
import BaseNav from '@/components/BaseNav'
import BaseDropdown from '@/components/BaseDropdown'
import CloseButton from '@/components/CloseButton'
import { headroom } from 'vue-headroom'
import IconLogoHorizontal from '../views/components/icons/logoHorizontal.vue'

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown,
    headroom,
    IconLogoHorizontal,
  },
}
</script>
<style>
</style>
